import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

/**
 * Shared MSAL instance exported so both App.tsx (MsalProvider)
 * and the axios interceptor (api.ts) can reference the same instance.
 */
export const msalInstance = new PublicClientApplication(msalConfig);
